import { humanize } from '@/views/tech-support/integrations/model'

export const STATUSES = {
  queued: { label: 'Queued', tone: 'blue' },
  running: { label: 'Running', tone: 'blue' },
  succeeded: { label: 'Done', tone: 'green' },
  skipped: { label: 'Skipped', tone: 'neutral' },
  failed: { label: 'Error', tone: 'red' }
}

export const STATUS_OPTIONS = Object.keys(STATUSES).map(value => ({ value, label: STATUSES[value].label }))

const REASONS = {
  no_ticket: 'The conversation is not linked to a Trengo ticket.',
  no_manual_reply: 'No reply written by a manager was found in the ticket.',
  no_client_messages: 'The customer wrote nothing before the manager reply.',
  empty_reply: 'The manager reply has no text.',
  reply_too_long: 'The manager reply is too long to rate.',
  not_in_history: 'The reply is not in Communication History yet.',
  invalid_request: 'The analysis request was rejected.',
  invalid_result: 'The AI returned an answer that could not be used.',
  BudgetExhausted: 'The AI spend limit is used up.',
  AnalysisMisconfigured: 'The AI service is not configured or kept returning unusable answers.',
  NothingToRate: 'The texts are empty once personal data is removed.',
  failed: 'The analysis job failed.',
  cancelled: 'The analysis job was cancelled.'
}

export function statusOf(status) {
  return STATUSES[status] || { label: humanize(status), tone: 'neutral' }
}

export function reasonLabel(code) {
  return code ? REASONS[code] || humanize(code) : ''
}

export function scoreTone(score) {
  if (score >= 8) return 'green'
  if (score >= 5) return 'amber'
  return 'red'
}

export function isActive(row) {
  return row.status === 'queued' || row.status === 'running'
}

export function cleanQuery(query) {
  return Object.keys(query).reduce((result, key) => {
    const value = query[key]
    if (value !== undefined && value !== null && value !== '') result[key] = String(value)
    return result
  }, {})
}
